import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-orange-50 pt-20 pb-8">
      <div className="max-w-7xl mx-auto px-6">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* About Section */}
          <div>
            <Link to="/" className="inline-block mb-4">
              <img 
                src="https://static.readdy.ai/image/a7a45bef519addb86f62650fa4d00e15/f12461d740e8c3a7e92fb8892e69dcde.png" 
                alt="JuarezMX Logo" 
                className="h-16 w-auto"
              />
            </Link>
            <p className="text-zinc-600 text-sm leading-relaxed mb-4">
              Your trusted guide to Ciudad Juárez, connecting visitors with authentic dining experiences, medical tourism, attractions, and local insights.
            </p>
            <Link 
              to="/" 
              className="text-sm text-orange-600 hover:text-orange-700 font-semibold transition-colors inline-flex items-center gap-1"
            >
              Visit Homepage
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          {/* Explore */}
          <div>
            <h4 className="font-bold text-zinc-900 mb-4">Explore</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/attractions" className="text-zinc-600 hover:text-orange-600 transition-colors cursor-pointer">
                  Attractions
                </Link>
              </li>
              <li>
                <Link to="/places-to-eat" className="text-zinc-600 hover:text-orange-600 transition-colors cursor-pointer">
                  Places to Eat
                </Link>
              </li>
              <li>
                <Link to="/border-crossing-wait-times" className="text-zinc-600 hover:text-orange-600 transition-colors cursor-pointer">
                  Border Crossings
                </Link>
              </li>
              <li>
                <Link to="/peso-dollar-exchange-rate" className="text-zinc-600 hover:text-orange-600 transition-colors cursor-pointer">
                  Peso Dollar Exchange
                </Link>
              </li>
              <li>
                <Link to="/viral-news-juarez-mx" className="text-zinc-600 hover:text-orange-600 transition-colors cursor-pointer">
                  Viral News
                </Link>
              </li>
            </ul>
          </div>

          {/* About */}
          <div>
            <h3 className="font-bold text-zinc-900 mb-4 text-sm uppercase tracking-wider">About</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/learn-about-juarez-mexico" className="text-zinc-600 hover:text-orange-600 transition-colors">
                  Juarez Mexico
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-zinc-600 hover:text-orange-600 transition-colors">
                  Contact &amp; Advertise
                </Link>
              </li>
              <li>
                <a href="#" className="text-zinc-600 hover:text-orange-600 transition-colors">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="#" className="text-zinc-600 hover:text-orange-600 transition-colors">
                  Terms of Service
                </a>
              </li>
            </ul>
          </div>

          {/* Connect */}
          <div>
            <h3 className="font-bold text-zinc-900 mb-4 text-sm uppercase tracking-wider">Connect</h3>
            <div className="flex gap-3 mb-6">
              <a
                href="https://www.facebook.com/NuestroJuarez/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white rounded-lg flex items-center justify-center text-zinc-600 hover:text-orange-600 hover:bg-orange-50 transition-all border border-zinc-200 cursor-pointer"
              >
                <i className="ri-facebook-fill text-xl"></i>
              </a>
            </div>
            <p className="text-sm text-zinc-600 leading-relaxed">
              Follow us for the latest updates on Juarez's best spots and hidden gems.
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-orange-200 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-zinc-600 text-sm">
            © 2024 JuarezMX.com. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a 
              href="https://juarezmx.com/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-sm text-zinc-500 hover:text-orange-600 transition-colors"
            >
              Ciudad Juárez Mexico
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
